module.exports = __webpack_public_path__ + "static/sf_5.be1a225e.png";